// AI Generated Test
import { Component, OnInit, Input } from '@angular/core';
import { PagePageLinksRepoService } from '@client/app/services/api/pages/page-links-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { MonImgMetadataOverlayComponent } from '@monsido/ng2/modules/inventory/components/img-metadata-overlay/img-metadata-overlay.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'page-details-section-inventory-links',
    standalone: false,
    template: `
        <div class="d-flex align-items-center mb-2">
            <span class="fa-2x fa-fw mr-2 text-link mt-1" aria-hidden="true" [class]="icon"></span>
            <div>
                <h2 class="font-weight-300 mb-0">
                    {{ headline }}
                </h2>
                @let total = links.total | monNumber;
                <span class="text-grey" translate [translate-args]="{$count: total}">
                    [[$count]] found
                </span>
            </div>
        </div>
        <mon-tabs
            (onSearch)="onSearch($event)"
            [search]="search"
            [minSearchLength]="1"
            [showSearch]="true">
            <csv-export-button *ngIf="type == 'link'" [exports]="exports"></csv-export-button>
        </mon-tabs>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <table-container
                        noResultMessage="{{ 'No content was found' | translate:'page-details -> Inventory -> links. No result message' }}"
                        [collection]="links"
                        (onPageChange)="onPageChange($event)"
                        (onPerPageChange)="onPageSizeChange($event)"
                        [progress]="promise">
                    <table class="table table-hover table-fixed table-vertial-align">
                        <thead>
                        <tr>
                            <th class="col-32">
                                <span class="inline-block pl-3" translate>Link</span>
                            </th>
                            <th class="col-5"></th>
                            <th class="col-5 text-right" translate>Type</th>
                            <th class="col-5 text-right">
                                <span class="inline-block pr-3" translate>Response code</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let link of links">
                            <td class="text-v-middle text-ellipsis">
                                <span class="inline-block col-48 pr-0 text-ellipsis">
                                    <span class="fas fa-unlink text-danger"
                                          *ngIf="link.link.type === 'link' && link.link.status_code === 404"
                                          ngbTooltip="{{ 'Link is broken' | translate }}" [triggers]="'focus hover'">
                                    </span>
                                    <a data-test="link-file" *ngIf="link.link.url !== ''" [href]="link.link.url"
                                       target="_blank" aria-describedby="linkOpensInNewTab">
                                        {{ link.link.url }}
                                    </a>

                                    <p class="m-0 text-italic" translate *ngIf="link.link.url === ''">
                                        Empty mailto
                                    </p>

                                </span>
                            </td>
                            <td class="text-right text-v-middle">
                                <button class="btn btn-border-radius btn-secondary mr-1"
                                        *ngIf="hasAccessToMetaDataOverlay && link.link.type === 'image' && link.link.status_code !== 404"
                                        [triggers]="'focus hover'"
                                        ngbTooltip="{{'Open metadata view' | translate}}"
                                        (click)="openMetadataModal(link)"
                                        monEventTrigger="actionTrigger"
                                        [monEventParams]="{action: 'open-metadata-view', params: {module: moduleName}}">
                                            <span class="fas fa-info-circle" aria-hidden="true"></span>
                                        </button>
                            </td>
                            <td class="text-right text-v-middle"><span class="label label-default">{{ link.link.type | capitalize}}</span></td>
                            <td class="text-right text-v-middle">
                                <span class="inline-block mr-3">
                                    {{ link.link.status_code}}
                                </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </table-container>
            </div>
        </div>
    `,
})
export class PageDetailsSectionInventoryLinksComponent extends BaseContainerComponentController implements OnInit {
    @Input() type: string = '';
    @Input() headline: string = '';
    @Input() icon: string = '';
    @Input() pageObj: any = {};

    links: any = [];
    hasAccessToMetaDataOverlay: boolean = false;
    exports: any[] = [];
    moduleName: string = '';
    promise: any;

    constructor (
        private pagePageLinksRepoService: PagePageLinksRepoService,
        private translateService: TranslateService,
        private activeFeatureService: ActiveFeatureService,
        private monEventService: MonEventService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.pageObj = this.pageObj || {};
        this.links = [];
        this.search = '';
        this.hasAccessToMetaDataOverlay = this.activeFeatureService.isFeatureActive('image_metadata');

        this.getPage = () => this.getPageData();
        this.getPage();
        this.setExports(this.pageObj.id);
    }

    getPageData (): void {
        const params = {
            page_size: this.pageSize,
            page: this.page,
            type: this.type,
            search: this.search ?? '',
        };

        this.promise = this.pagePageLinksRepoService.getAll(this.pageObj.id, params).then((data: any) => {
            this.links = data;
        }, () => {});
    }

    setExports (pageId: string): void {
        this.exports = [
            {
                name: this.translateService.getString('Page Links'),
                data: {
                    category: 'page_links_for_page',
                    category_ref: pageId,
                },
            },
        ];
    }

    openMetadataModal (link: any): void {
        const params = {
            component: MonImgMetadataOverlayComponent,
            data: { linkUrl: link.link.url, linkId: link.link.id },
            dialogOptions: {
                size: 'md',
            },
        };

        this.monEventService.run(MON_EVENTS.LOAD_NG2_DIALOG, params);
    }

    trackByIndex (index: number): number {
        return index;
    }
}
